// extracted by mini-css-extract-plugin
export default {"productCategoryCell":"TagCell_productCategoryCell__7QrOY","tagCell":"TagCell_tagCell__F9Osi","tagItem":"TagCell_tagItem__BmaV3","isRed":"TagCell_isRed__VgqrH"};